module.exports = __webpack_public_path__ + "static/media/rise_of_olympus.playngo.f73a8489.jpeg";